import React from "react";
import PropTypes from "prop-types";

export interface DragMProps {
  style?: React.CSSProperties;
  maxTransformX: number;
  maxTransformY: number;
  children: React.ReactElement;
  updateTransform: (transformStr: string, tx?: number, ty?: number, tdom?: HTMLElement) => void;
}

export default class DragM extends React.Component<DragMProps> {

  tdom: HTMLElement | undefined = undefined;

  static propTypes = {
    children: PropTypes.element.isRequired,
  };
  static defaultProps = {
    //默认是移动children dom,覆盖该方法，可以把tranform行为同步给外部
    // @ts-ignore
    updateTransform: (transformStr: string, tx: number, ty: number, tdom: HTMLElement) => {
      tdom.style.transform = transformStr;
    }
  };
  position = {
    startX: 0,
    startY: 0,
    dx: 0,
    dy: 0,
    tx: 0,
    ty: 0
  };

  start = (event: MouseEvent) => {
    if (event.button != 0) {
      //只允许左键，右键问题在于不选择conextmenu就不会触发mouseup事件
      return;
    }
    document.addEventListener("mousemove", this.docMove);
    this.position.startX = event.pageX - this.position.dx;
    this.position.startY = event.pageY - this.position.dy;
  };

  docMove = (event: MouseEvent) => {
    const { maxTransformX, maxTransformY, updateTransform } = this.props;
    const tx = Math.abs(event.pageX - this.position.startX) > maxTransformX
      ? event.pageX - this.position.startX > 0
        ? maxTransformX : -maxTransformX : event.pageX - this.position.startX;
    const ty = Math.abs(event.pageY - this.position.startY) > maxTransformY
      ? event.pageY - this.position.startY > 0
        ? maxTransformY : -maxTransformY : event.pageY - this.position.startY;
    const transformStr = `translate(${tx}px,${ty}px)`;
    updateTransform(transformStr, tx, ty, this.tdom);
    this.position.dx = tx;
    this.position.dy = ty;
  };

  // @ts-ignore
  docMouseUp = (event: MouseEvent) => {
    document.removeEventListener("mousemove", this.docMove);
  };

  componentDidMount() {
    if (this.tdom) {
      this.tdom.addEventListener("mousedown", this.start);
    }
    //用document移除对mousemove事件的监听
    document.addEventListener("mouseup", this.docMouseUp);
  }

  componentWillUnmount() {
    if (this.tdom) {
      this.tdom.removeEventListener("mousedown", this.start);
    }
    document.removeEventListener("mouseup", this.docMouseUp);
    document.removeEventListener("mousemove", this.docMove);
  }

  render() {
    const { children } = this.props;
    const newStyle = { cursor: "move", userSelect: "none" };
    return React.cloneElement(React.Children.only(children), {
      ref: (tdom: HTMLElement) => {
        return (this.tdom = tdom);
      },
      style: newStyle
    });
  }
}
